/**
 * ユーザー関連のサービス
 *
 * AI検索回数の月次リセットなどを管理
 */

import { doc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

/**
 * 月次リセットをチェックし、必要に応じて実行
 *
 * 現在の年月と lastResetDate の年月を比較し、
 * 月が変わっていれば AI検索回数をリセットする
 *
 * @param {string} userId - ユーザーID
 * @returns {Promise<boolean>} リセットが実行されたかどうか
 */
export async function checkAndResetMonthlyCount(userId) {
  if (!userId) return false;

  try {
    const userRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userRef);

    if (!userDoc.exists()) {
      console.log('[KnoVelo Users] ユーザードキュメントが存在しません');
      return false;
    }

    const userData = userDoc.data();
    const now = new Date();

    // lastResetDate が存在しない場合は、初回として現在日時を設定し、回数もリセット
    // （既存ユーザーで lastResetDate がない場合、いつリセットされたか不明なため）
    if (!userData.lastResetDate) {
      console.log('[KnoVelo Users] lastResetDate が未設定のため、初期化してリセットします');
      await updateDoc(userRef, {
        monthlyQueryCount: 0,
        lastResetDate: serverTimestamp()
      });
      return true; // リセットが実行されたことを示す
    }

    // Firestore Timestamp を Date に変換
    const lastReset = userData.lastResetDate.toDate
      ? userData.lastResetDate.toDate()
      : new Date(userData.lastResetDate);

    // 年または月が変わっているかチェック
    const isNewMonth =
      now.getFullYear() !== lastReset.getFullYear() ||
      now.getMonth() !== lastReset.getMonth();

    if (isNewMonth) {
      console.log('[KnoVelo Users] 月が変わったため、AI検索回数をリセットします');
      console.log('[KnoVelo Users] 前回リセット:', lastReset.toISOString());
      console.log('[KnoVelo Users] 現在:', now.toISOString());

      await updateDoc(userRef, {
        monthlyQueryCount: 0,
        lastResetDate: serverTimestamp()
      });

      console.log('[KnoVelo Users] リセット完了');
      return true;
    }

    console.log('[KnoVelo Users] リセット不要（同月内）');
    return false;
  } catch (error) {
    console.error('[KnoVelo Users] 月次リセットチェックエラー:', error);
    // エラーが発生してもユーザー体験を妨げないよう、falseを返す
    return false;
  }
}
